import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import { StateKeys } from "../../redux/states/main.state";
import {
  AppPageScrollDownLoadMore,
  AppState,
  getLanguageByDefault,
} from "../../services/app.service";
import Main from "../../redux/actions/main.action";
import ApiEndpoint from "../../services/api.endpoint.service";
import Loader from "../../components/Loader";
import Card from "../../components/Card";
import { CertificateModelResponse } from "../../services/api.response.service";
import NoData from "./NoData";
import GoBack from "../../components/GoBack";
import CertificateModal from "../../components/CertificateModal";

function Certificates() {
  const dispatch = useDispatch();
  const state = useSelector((state: IRootState) => state.main);
  const getLanguage = getLanguageByDefault();

  const { data, pageState, hasMore, currentPage } = state[StateKeys.CERTIFICATES];

  const [certificateUrl, setCertificateUrl] = useState<string | undefined>();
  const [certificateOwner, setCertificateOwner] = useState<CertificateModelResponse | undefined>();
  const [showCertificateModal, setShowCertificateModal] = useState(false);

  useEffect(() => {
    if (pageState !== AppState.LOADED && pageState !== AppState.LOADING) {
      dispatch(
        Main.getPaginatedPageData({
          stateKey: StateKeys.CERTIFICATES,
          apiEndpoint: ApiEndpoint.USER_CERTIFICATES,
          previousPage: currentPage!,
        })
      );
    }
  }, []);
  
      const handleCloseCertificateModal = () => setShowCertificateModal(false);
      const handleShowCertificateModal = (url: string) => {
        setCertificateUrl(url);
        setShowCertificateModal(true);
      };


      const handleCertificateModal = (url: CertificateModelResponse) => {
          setCertificateOwner(url)
          handleShowCertificateModal(url.view_url)
      };

  const loadMore = () => {
    if (
      // @ts-ignore
      window.innerHeight + document.documentElement.scrollTop ===
        // @ts-ignore
        document.scrollingElement.scrollHeight &&
      // @ts-ignore
      hasMore &&
      // @ts-ignore
      (pageState !== AppState.LOADING || pageState !== AppState.LOADING_MORE)
    ) {
      dispatch(
        Main.getPaginatedPageData({
          stateKey: StateKeys.CERTIFICATES,
          apiEndpoint: ApiEndpoint.USER_CERTIFICATES,
          previousPage: currentPage!,
        })
      );
    }
  };

  return (
    <div
      className="content-page scroller-hide"
      onScroll={(e) => AppPageScrollDownLoadMore(e, loadMore)}
    >
      <Row>
        {" "}
        <GoBack />
        <h5
          style={{
            fontSize: "24px",
            fontWeight: 400,
          }}
        >
          {getLanguage.certificates}
        </h5>
        <Col sm={12} className="row m-0 p-0">
          {(pageState === AppState.LOADED ||
            pageState === AppState.LOADING_MORE) && (
            <>
              { (data && data.length > 0) ? (
                (data as Array<CertificateModelResponse>).map(
                  ({
                       id,
                       certificate,
                       view_url ,
                       pdf_url ,
                       image_url ,
                   }, i) => (
                    <Col key={i} sm={12} md={6} className="mt-3" onClick={() => handleCertificateModal({
                        id,
                        certificate_number: "",
                        certificate: certificate,
                        view_url: view_url,
                        pdf_url: pdf_url,
                        image_url: image_url,
                        created_at: "",
                        updated_at: ""
                    })}>
                      <Card className="mb-1 d-flex ">
                          <Card.Body>
                            <h5 className="course-fw">
                                {certificate?.title}
                            </h5>
                              {/*<div className="col-11"><span title="Total Topics">3 Sujets </span><h5 className="course-fw ">Course 1</h5></div>*/}
                            <small className="text-secondary d-flex  gap-1"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Total Available Classes"
                            >
                              <span >
                                {certificate?.name}
                              </span>
                            </small>

                          </Card.Body>
                        </Card>
                    </Col>
                  )
                )
              ) : (
                <NoData title="No Certificates available" />
              )}
            </>
          )}
        </Col>
        <Col md={12}>
          {(pageState === AppState.LOADING_MORE ||
            pageState === AppState.LOADING) && <Loader noCard imageLoader />}
        </Col>
      </Row>
      <CertificateModal
                show={showCertificateModal}
                onHide={handleCloseCertificateModal}
                url={certificateUrl}
                certificateOwner={certificateOwner}
            />
    </div>
  );
}

export default Certificates;
